export interface TaskOption{
	optID:string;
	optVal:number;
}

export interface TaskDataMeta{
	contentType: string;
	contentTitle: string;
	creatorMail:string;
	taskTitle:string;
	scoreType: string;
	pageDir: string;
	taskOptions: TaskOption[];
	classCode: string;
	welcomeMsg: string;
}

export interface TaskDataTableRow{
	rank:number;
	name:string;
	complete:string;
	score:number;
}

export interface TaskData{
	metaData:TaskDataMeta;
	tableData:TaskDataTableRow[];
}

export interface TaskListItem{
	taskTitle: string;
	meta?: TaskDataMeta;
}

export function createTaskListItem(title: string): TaskListItem {
	return {
		taskTitle: title
	};
}

export enum TaskControlsAction {
	View = 'VIEW',
	Open = 'OPEN',
	Delete = 'DELETE',
	Reset = 'RESET'
}

export enum TaskStatus{
	Default='DEFAULT',
	GetList='GETLIST',
	GetListError='GETLISTERROR',
	GetTask='GETTASK',
	GetTaskDataError='GETTASKDATAERROR',
	GetTaskMetaError='GETTASKMETAERROR',
	ResetTask='RESETTASK',
	ResetTaskFailed='RESETTASKFAILED',
	DeleteTask='DELETETASK',
	DeleteTaskFailed='DELETETASKFAILED',
	Creating='CREATING',
	CreateSuccess='CREATESUCCESS',
	CreateFailed='CREATEFAILED',
	CreateDelete='CREATEDELETE'
}
